<template>
  <AccountContent />
</template>

<script setup>
import AccountContent from "@/components/profile/AccountContent.vue";
</script>
